module.exports = __webpack_public_path__ + "img/12.7937c6d8.jpg";